$(document).ready(function(){


    /* Filter */


    $('.gallery_filter a').on('click', function(e){     //button event handler

        $('.gallery_filter a').removeClass('active');           //remove active marker
        $(this).addClass('active');                             //add new active marker

        $('.gallery_block a').each(function(index, item){           //for each gallery image
           $(item).hide().removeClass('visible');               //hide images and remove visible markers
            if ($(item).children('img').attr('title') === undefined) {          //images without title attributes
                $(item).children('img').attr('title',' ');                //receive an attribute with only a space
            }                                                          //to avoid errors

            if ($(item).children('img').attr('title').includes(e.target.id)) {   //check, if the title attribute contains the button id
                $(item)
                    .show()                                             //show the image
                    .addClass('visible');                         //and mark as visible
            }
        });

        $('div').remove('.pagination');                         //remove old pagination
        paging();                                                       //build new pagination
        $('.pagination_item:first-child').addClass('current');    //mark first page menu item

    });

    $('#alles').on('click', function(e){                   //event handler for "all" button

        $('.gallery_filter a').removeClass('active');              //remove active marker
        $(this).addClass('active');                                //add new active marker

        $('.gallery_block a').show().addClass('visible');        //show all and mark all as visible

        $('div').remove('.pagination');                           //remove old pagination
        paging();                                                         //build new pagination
        $('.pagination_item:first-child').addClass('current');     //mark first page menu item
    });


    /* Paging */



    function paging() {

        var items = 12;              //Insert number of images per page here!

        var page;
        var startindex = 0;                                        //initialize startindex
        var block = $('.gallery_block');
        var image = $('.gallery_block a').filter('.visible');    //filter for visible images
        var length = image.length;                                 //number of visible images
        var pages  = Math.floor(length/items + 1);              //calculate number of pages


        if (length > items) {                               //if pagination necessary

            /* Crop Items */

            image.hide();                                    //hide all

            var visible = image.slice(startindex,items);     //crop images and store selection in new variable
            visible.show();                                  //show selected images

            /* Add Page Menu */

            block.after('<div class="pagination"></div>');    //insert pagination menu

            for (var j=1; j <= pages; j++) {                  //insert pages into menu
                $('.pagination').append('<a href="#gallery_top" class="pagination_item">' + j + '</a>')
            }

            /* Eventhandler for Pagination */

            $('.pagination_item').on('click', function(){
                page = $(this).text();                                      //save page number
                startindex = (page - 1) * items + 1;                        //calculate new start index for images

                $('.pagination_item').removeClass('current');         //remove marker
                $(this).addClass('current');                          //add new marker

                image.hide();                                               //hide all

                var visible = image.slice(startindex,startindex+items);     //change to next image selection via startindex
                visible.show();                                             //show new images
            });
        }
    }


    /* Initialization */


    paging();                                                              //execute paging
    $('.pagination_item:first-child').addClass('current');           //mark first page menu item


});